import { RouterProvider } from '@tanstack/react-router';
import Favicon from 'components/Favicon/Favicon.component';
import { PageTitle } from 'components/page-title';
import React, { ErrorInfo, ReactNode } from 'react';
import { LocalizeProvider } from 'react-localize-redux';
import { Provider } from 'react-redux';
import { router } from 'routers/routers.instance';
import { selectUrlBasename } from 'services/session/session.selectors';
import { AppStore } from 'store/types';
import { GlobalStyles } from 'style/globals';
import { GridThemeProvider } from 'styled-bootstrap-grid';
import { ThemeProvider } from 'styled-components';
import { Grid, Theme } from 'theme';
import { createScopedErrorHandler } from 'utils/functions/handleError';

export type AppProvidersProps = {
  theme: Theme;
  grid: Grid;
  store: AppStore;
  children?: ReactNode;
};

export type AppProvidersState = {
  basename: string;
};

class AppProviders extends React.PureComponent<
  AppProvidersProps,
  AppProvidersState
> {
  static handleError = createScopedErrorHandler('react');

  constructor(props: AppProvidersProps) {
    super(props);

    this.state = {
      basename: selectUrlBasename(props.store.getState()),
    };
  }

  // Behaves similarly to a try catch block.
  // Catches Expections that occurs during render,
  // hooks runtime, lifecycle component hooks and synthetic events runtime.
  // Docs: https://reactjs.org/docs/react-component.html#componentdidcatch
  componentDidCatch(error: any, errorInfo: ErrorInfo) {
    const thingsToLog = [error];

    if (!import.meta.env.PROD) {
      thingsToLog.push(errorInfo);
    }

    AppProviders.handleError.apply(null, thingsToLog);
  }
  render() {
    const { store, theme, grid } = this.props;
    return (
      <Provider store={store}>
        <LocalizeProvider store={store}>
          <ThemeProvider theme={theme}>
            <GlobalStyles />
            <Favicon />
            <PageTitle />
            <GridThemeProvider gridTheme={grid}>
              <RouterProvider router={router} />
            </GridThemeProvider>
          </ThemeProvider>
        </LocalizeProvider>
      </Provider>
    );
  }
}

export default AppProviders;
